import { stateReducer } from './stateReducer';
import { combineReducers } from '@ngrx/store';

export const reducer = combineReducers({
  stateReducer: stateReducer
});

const reducers = {
    stateReducer
};

// const developmentReducer = compose(storeFreeze, combineReducers)(reducers);
const productionReducer = combineReducers(reducers);

export function appReducer(state: any, action: any) {
    return productionReducer(state, action);
    // if (environment.production) {
    //   return productionReducer(state, action);
    // } else {
    //   return developmentReducer(state, action);
    // }
}



// WEBPACK FOOTER //
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/store/reducers.ts